import * as actionTypes from 'constants/ActionTypes';

export function logoutUser() {
    return {
        type: actionTypes.LOGOUT_USER.REQUEST,
    };
}

export function getUser() {
    return {
        type: actionTypes.GET_USER.REQUEST,
    };
}

export function authUser(email, password) {
    return {
        type: actionTypes.AUTH_USER.REQUEST,
        email,
        password,
    };
}

export function getUserList(pagination) {
    return {
        type: actionTypes.GET_USER_LIST.REQUEST,
        pagination
    };
}

export function banUserById(user) {
    return {
        type: actionTypes.BAN_USER_BY_ID.REQUEST,
        user,
    };
}

export function unbanUserById(user) {
    return {
        type: actionTypes.UNBAN_USER_BY_ID.REQUEST,
        user,
    };
}

export function addUsersFromAutocomplete(users) {
    return {
        type: actionTypes.ADD_USERS_FROM_AUTOCOMPLETE,
        users,
    };
}

export function getUserLimitationsList() {
    return {
        type: actionTypes.GET_USER_LIMITATIONS_LIST.REQUEST,
    };
}

export function setUserToBlackList(emails, user) {
    return {
        type: actionTypes.SET_USER_TO_BLACK_LIST.REQUEST,
        emails,
        user,
    }
}

export function setUserToWhiteList(emails, user) {
    return {
        type: actionTypes.SET_USER_TO_WHITE_LIST.REQUEST,
        emails,
        user,
    }
}

export function toggleWhiteList(user, whiteActive) {
    return {
        type: actionTypes.TOGGLE_WHITE_LIST.REQUEST,
        user,
        whiteActive,
    }
}


// todo change bane file to users


// WEBPACK FOOTER //
// ./app/actions/users/index.js